import React, { useState } from 'react'
import { Store } from '../../context/store'
import { useInterval } from '../../hooks'
import Container from '../../components/Container'
import { InfoBarStyled, InfoBarContent, InfoBarOffline } from './styled'
import { differenceInMinutes, fromUnixTime, format } from 'date-fns'
import { isNotNil } from '../../helpers'
import { isNil } from 'ramda'

const InfoBar = React.memo(({ lastUpdate, translation, noContainer }) => {
  const { state: { app: { online } } } = Store()
  const [delay, setDelay] = useState(1000)

  useInterval(() => {
    if (differenceInMinutes(new Date(), fromUnixTime(lastUpdate)) >= 10 && isNotNil(delay)) {
      setDelay(null)
    }
  }, delay)

  return (
    <InfoBarStyled>
      {
        noContainer ?
          <>
            {
              !online &&
              <InfoBarOffline>Offline</InfoBarOffline>
            }
            {
              lastUpdate &&
              <InfoBarContent
                isInvalid={isNil(delay) || !online}
              >
                {`${translation && translation.info} ${format(fromUnixTime(lastUpdate), 'HH:mm')}`}
              </InfoBarContent>
            }
          </>
          :
          <Container>
            {
              !online &&
              <InfoBarOffline>Offline</InfoBarOffline>
            }
            {
              lastUpdate &&
              <InfoBarContent
                isInvalid={isNil(delay) || !online}
              >
                {`${translation && translation.info} ${format(fromUnixTime(lastUpdate), 'HH:mm')}`}
              </InfoBarContent>
            }
          </Container>
      }

    </InfoBarStyled>
  )
})

InfoBar.defaultProps = {
  noContainer: false
}

export default InfoBar